function bindSpinnerClickEvents(delay = 0) {
  setTimeout(() => {
    document.querySelectorAll(".product-card-spinner").forEach((spinner) => {
      // Avoid rebinding if already bound
      if (spinner.dataset.bound === "true") return;

      let isDragging = false;
      let startX = 0;

      spinner.addEventListener("mousedown", function (e) {
        isDragging = false;
        startX = e.clientX;
      });

      spinner.addEventListener("mousemove", function (e) {
        if (Math.abs(e.clientX - startX) > 5) {
          isDragging = true;
        }
      });

      spinner.addEventListener("mouseup", function (e) {
        console.log("mouse clicked on spinner");
        if (!isDragging) {
          const url = this.getAttribute("data-url");
          if (url) {
            window.location.href = url;
          }
        }
      });

      spinner.addEventListener("click", function (e) {
        if (isDragging) e.preventDefault();
      });

      // Mark as bound to avoid double-binding
      spinner.dataset.bound = "true";
    });
  }, delay);
}

// Optionally call it once after page load
window.addEventListener("DOMContentLoaded", () => {
  bindSpinnerClickEvents(1000); // or 0 if no delay needed
});
